import { render, staticRenderFns } from "./fixedMenu.vue?vue&type=template&id=0d9cd555&"
import script from "./fixedMenu.vue?vue&type=script&lang=js&"
export * from "./fixedMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/ctrl/fixedMenu/fixedMenu.vue"
export default component.exports